import { render } from "./FacialHarmonizationContentEs.vue?vue&type=template&id=184b62e3"
import script from "./FacialHarmonizationContentEs.vue?vue&type=script&lang=js"
export * from "./FacialHarmonizationContentEs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__